export const ModuleEnum = {
  INSPECTION_MANAGEMENT: 'INSPECTION_MANAGEMENT',
} as const;
